// Moving Average Indicators
export class MovingAverages {
    /**
     * Calculate Simple Moving Average
     */
    static calculateSMA(data: number[], period: number): number[] {
        const sma: number[] = [];
        for (let i = period - 1; i < data.length; i++) {
            const sum = data.slice(i - period + 1, i + 1).reduce((a: number, b: number) => a + b, 0);
            sma.push(sum / period);
        }
        return sma;
    }

    /**
     * Calculate Exponential Moving Average
     */
    static calculateEMA(data: number[], period: number): number[] {
        const multiplier = 2 / (period + 1);
        const ema: number[] = [data[0]];

        for (let i = 1; i < data.length; i++) {
            ema.push(data[i] * multiplier + ema[i - 1] * (1 - multiplier));
        }
        return ema;
    }

    /**
     * Calculate Weighted Moving Average
     */
    static calculateWMA(data: number[], period: number): number[] {
        const wma: number[] = [];
        const weights = Array.from({ length: period }, (_, i) => i + 1);
        const weightSum = weights.reduce((a, b) => a + b, 0);

        for (let i = period - 1; i < data.length; i++) {
            let weightedSum = 0;
            for (let j = 0; j < period; j++) {
                weightedSum += data[i - j] * weights[j];
            }
            wma.push(weightedSum / weightSum);
        }

        return wma;
    }

    /**
     * Calculate Volume Weighted Moving Average
     */
    static calculateVWMA(prices: number[], volumes: number[], period: number): number[] {
        const vwma: number[] = [];

        for (let i = period - 1; i < prices.length; i++) {
            let volumeSum = 0;
            let priceVolumeSum = 0;

            for (let j = 0; j < period; j++) {
                const volume = volumes[i - j] || 1;
                volumeSum += volume;
                priceVolumeSum += prices[i - j] * volume;
            }

            vwma.push(priceVolumeSum / volumeSum);
        }

        return vwma;
    }
}
